import NR1DashboardsHub from "@/pages/NR1DashboardsHub";

export default function DashboardsHubCanal() {
  return <NR1DashboardsHub forcedVariant="channel" />;
}
